<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="query['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="query['order.no']" placeholder="placeholder.receiptOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['customer.name']" placeholder="business.label.customerName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading" @cell-click="({row})=>showDetails(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
        <vxe-column field="customer.name" title="business.label.customerName"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="asnOrder.orderStatus" title="business.label.orderStatus" width="100"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <shelf-task ref="shelfTask"/>
  </div>
</template>

<script>
import moment from 'moment'
import { findAll } from '@/api/Api'
import ShelfTask from '@/views/inbound/shelf/ShelfTask.vue'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'ShelfByOrder',
  components: { ShelfTask },
  data() {
    return {
      loading: false,
      data: [],
      owners: [],
      orderStatus: [],
      page: 1,
      size: 5,
      contentSize: 0,
      query: {
        'order.no': '',
        'customer.name': '',
        'owner.id': undefined,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('OrderStatus')
    }).then(result => {
      this.orderStatus = result
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['dateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateFilter'] = null
      }
      findAll('receivingReceiptListFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          this.$refs.shelfTask.reset()
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'order.no': '',
        'customer.name': '',
        'owner.id': undefined,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    showDetails(row) {
      this.$refs.shelfTask.refresh({ 'order.id': row.order.id })
    },
    confirm() {
      this.$refs.shelfTask.putaway()
    }
  }
}
</script>